module.exports = __webpack_public_path__ + "static/media/plus_blue.ece44997.svg";